import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { Container, Input, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useNavigate } from "react-router-dom";
import "../../share/form.css";
import { BsPlusCircle } from "react-icons/bs";
import "../../share/TableLanding.css";
import CreateTableComponent from "../../share/CreateTableComponent";
import { FiEdit } from "react-icons/fi";
import { NumberWithCommas } from "../../share/NumberWithCommas";
import { NumericFormat } from 'react-number-format';
import { CustomInputNumeric } from "../../share/CustomInputNumeric";

export function YearbudgetLimitComponent() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("userData"));
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [FoundValue, setFoundValue] = useState(false);

  const modalToggle = () => {
    setModal(!modal)

  };


  useEffect(() => {
    async function GetProvince() {
      setLoading(true);
      try {
        const responseCondition = await fetch("/api/ContactBorrow/getyearbudgetlist");
        const data = await responseCondition.json();
        if (data !== null) {
          setFoundValue(true)
        }
        setData(data.dataenum);
      } catch (e) {
        console.log("err => " + e);
      } finally {
        setLoading(false);
      }
    }
    GetProvince();
  }, []);


  const formInitialValues = {
    budgetyear: "",
    amountlimit: "",
    Updateby: user.fullName,
    Createby: user.fullName,
    update: "0",
    budgetId: "",
  };

  const validateSchema = Yup.object().shape({});

  const onSubmit = async (values, action) => {

    console.log("Values", values);

    let postData = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      postData.append(key, value);
    });
    try {
      let res = await fetch("api/ContactBorrow/savebudgetyear", {
        method: "POST",
        // headers: { "Content-type": "application/json" },
        body: postData,
      });
      console.log("values5", values);
      let resJson = await res.json();

      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        }).then((result) => {
          modalToggle();
          action.resetForm();
          window.location.reload()
        });
      }
      else {
        Swal.fire({
          icon: "warning",
          title: "บันทึกข้อมูลไม่สำเร็จ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        })
      }
    } catch (e) {
      console.log(e);
    }

  };





  return (
    <Container>

      {/* รายละเอียดย่อย */}





      <Formik
        initialValues={formInitialValues}
        validationSchema={validateSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({
          values,
          handleChange,
          handleBlur,
          setFieldValue,
          setValues,
          resetForm,
          errors,
          touched,
        }) => {

          const closemodalToggle = () => {
            setModal(!modal)
            resetForm();
          };


          async function onEdit(id) {
            console.log("id", id);
            console.log("data", data);
            const found = data.find(({ budgetAmountId }) => budgetAmountId == id)
            console.log("found", found);

            setFieldValue("budgetyear", found.budget);
            setFieldValue("amountlimit", found.amount);
            setFieldValue("budgetId", id);
            setFieldValue("update", "1");

            modalToggle();


          }

          const COLUMNS = [
            {
              Header: "ลำดับ",
              accessor: (_row, i) => i + 1,
              enableRowSpan: true,
            },
            {
              Header: "ประจำปีงบประมาณ w.ศ ",
              accessor: "budget",
              // Cell: ({ value }) => {
              //   return <>{NumberWithCommas(value)} %</>;
              // },
            },
            {
              Header: "วงเงินให้กู้ยืม",
              accessor: "amount",
              Cell: ({ row, value }) => {
                return (
                  <>
                    {NumberWithCommas(row.original.amount)}
                    <FiEdit
                      className="mx-3 style-icon"
                      onClick={() =>
                        onEdit(row.original.budgetAmountId)
                      }
                    />
                  </>
                );
              },
            },


          ]


          return (
            <>
              <div className="d-flex align-items-center justify-content-end p-2 w-100">
                <button
                  onClick={() => modalToggle()}
                  type="button"
                  className="btn-green p-2"
                >
                  <BsPlusCircle className="mx-1" />
                  เพิ่มข้อมูล
                </button>
              </div>
              <CreateTableComponent column={COLUMNS} dataInput={data} showEntrie={true} showPage={true} />
              <Modal
                isOpen={modal}
                toggle={modalToggle}
                backdrop={"static"}
                keyboard={false}
                size="lg"

              >
                <ModalHeader
                  className="styled-modal input-color"
                  toggle={modalToggle}>
                  เพิ่มข้อมูลประจำปีงบประมาณ

                </ModalHeader>
                <ModalBody>
                  <div className="px-5 mt-5 d-flex justify-content-evenly">
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span className="type-register w-25">ประจำปีงบประมาณ</span>
                      <Field name={`budgetyear`}>
                        {({ field, form, meta }) => (
                          <Input
                            // disabled={disabled}
                            type="text"
                            className="w-75 rounded-pill text-center input-color"
                            {...field}
                            onChange={(e) => {
                              handleChange(e);

                            }}
                            onBlur={handleBlur}

                          ></Input>
                        )}
                      </Field>
                    </div>
                  </div>

                  <div className="px-5 mt-5 d-flex justify-content-evenly">
                    <div className="d-flex justify-content-evenly align-items-center w-100">

                      <div className="d-flex flex-column justify-content-evenly align-items-center w-100">



                        <div className="d-flex justify-content-between align-items-center w-100 ">
                          <span className="type-register w-25">
                            วงเงินให้กู้ยืม
                          </span>
                          
                          <Field name="amountlimit">
                            {({ field, meta, form: { setFieldValue, values } }) => (
                              <NumericFormat
                                {...field}

                                allowLeadingZeros
                                thousandSeparator=","
                                decimalScale={2}
                                isNumericString={true}
                                displayType="number"
                                value={values.amountlimit}
                                format={(value) => value.toLocaleString()}
                                onValueChange={(values, sourceInfo) => {
                                  let value1 = values.value.replace(/,/g, '')
                                  //   setFieldValue(field.name, values.value.replace(/,/g, ''))
                                  setFieldValue(field.name, value1)
                                }}
                                customInput={CustomInputNumeric}
                                className={meta.error && meta.touched ? "input-error" : ""}
                              />

                            )}
                          </Field>

                        </div>



                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-evenly text-center w-100">
                    <Form className="d-flex justify-content-evenly text-center w-100">
                      <button className="btn-green rounded-pill w-25 my-5" type="submit">
                        บันทึก
                      </button>

                      <button className="btn-red rounded-pill w-25 my-5"
                        type="button" onClick={() =>
                          closemodalToggle()

                        }>
                        ยกเลิก
                      </button>
                    </Form>
                  </div>
                </ModalBody>

              </Modal>
            </>
          );
        }}
      </Formik>
      <div class="boxes-tn">
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div>
            </div>
    </Container>
  );
}